module.exports = "<div class=\"center\">\n  <div class=\"content\">\n\n    <a [routerLink]=\"['/']\" class=\"logo\" tabindex=\"-1\">\n      <img src=\"assets/big-logo.png\">\n    </a>\n\n    <router-outlet\n      (activate)='onActivate($event)'\n      (deactivate)='onDeactivate($event)'>\n    </router-outlet>\n\n  </div>\n</div>\n\n<app-footer *ngIf=\"footerEnabled\" mode='dark'></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/simple-layout.component.html
// module id = ./src/app/layouts/simple-layout.component.html
// module chunks = main